import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";

import { Header } from "../../components/Header/";
import { LoginAdminIcon, LoginTeacherIcon, LoginStudentIcon} from "../../assets/icons";
import { API_URL } from "../../constants";

import './landing.styles.scss';
import content from "../../content";

export const Landing: React.FC = () => {
  // const [isAuth, setAuth] = useState<boolean>();
  // const [userRole, setUserRole] = useState<string>('');
  // const [error, setError] = useState(null);
  // const navigate = useNavigate();
  //
  // useEffect(() => {
  //   axios.get('http://localhost:8000/login', {
  //     withCredentials: true, // if using cookies for auth
  //   })
  //     .then(response => {
  //       console.log('landing');
  //     })
  //     .catch(err => {
  //       console.log('err.response?.data', err.response?.data);
  //     });
  // }, []);
  //
  // if (error) return <div>Error: {error}</div>;
  // if (!isAuth) {
  //   switch(userRole) {
  //     case USER_ROLE.student:
  //       navigate('/river-map');
  //       break;
  //     case USER_ROLE.teacher:
  //       navigate('/teacher-dashboard');
  //       break;
  //     case USER_ROLE.admin:
  //       navigate('/admin-dashboard');
  //       break;
  //   }
  // }

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/login`, {
      withCredentials: true, // if using cookies for auth
    })
      .then(response => {
        console.log('LOGIN REACT', response.data)

        const { auth, role } = response.data;

        if (auth && !!role.length) {

          console.log('LANDING REACT IN', role)
          // @ts-ignore
          console.log('LANDING PAGE_URL', content)
          // @ts-ignore

          navigate(content[role].PAGE_URL);
        }
        console.log('landing');
      })
      .catch(err => {
        console.log('err.response?.data', err.response?.data);
      });
  }, []);

  return (
    <>
      <Header goBack={false} logOut={false} />
      <main className="LandingContainer">
        <div className="ImageContainer">
          <img src="/images/login/classroom.webp" alt="Classroom" className="Image LandingImage"/>
        </div>
        <div className="LoginButtons">
          <Link to="/login/teacher" className="LoginButton">
            <LoginTeacherIcon className="Secondary"/>
            <span>Teacher</span>
          </Link>
          <Link to="/login/student" className="LoginButton">
            <LoginStudentIcon className="Primary"/>
            <span>Students</span>
          </Link>
          <Link to="/login/admin" className="LoginButton">
            <LoginAdminIcon className="Secondary"/>
            <span>Admin</span>
          </Link>
        </div>
      </main>
    </>
  );
};
